<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-card>
        <tt-input ttLabel="searchtext" ttFocus="true" [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
    </tt-card>

    <tt-list [ttData]="itemsListTimeCustomers" [ttFilter]="setting.searchtext"></tt-list>
</tt-page>
